import { Box, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import React, { useCallback } from 'react';
import { NavLink } from 'react-router-dom';
import '../AppSidebar.styles.css';
import getNavIcon from './menu.icon';
import { maskPath } from '../../shared/utils/utils';
import { getColors } from '../../theme';

const colors = getColors();

const NavLinkMui = React.forwardRef((props, forwardedRef) => (
  <NavLink {...props} ref={forwardedRef} />
));

function SingleLevelItem({ menu, open, children, onToggle }) {
  const { generalButton, colorShades } = colors;
  const { moduleName, caption, screenPath, icon, path } = menu;
  const Icon = useCallback(getNavIcon(icon));
  return (
    <ListItem onClick={onToggle} disablePadding sx={{ display: 'block' }}>
      <ListItemButton
        className="parent-menu"
        component={NavLinkMui}
        to={maskPath(path || screenPath)}
        sx={{
          minHeight: 45,
          justifyContent: open ? 'initial' : 'center',
          px: 2.5,
          py: 0,
        }}
      >
        <Box
          className="highlighter"
          sx={{
            width: 6,
            position: 'absolute',
            left: 0,
            height: 45,
            backgroundColor: generalButton.main,
            borderTopRightRadius: 5,
            borderBottomRightRadius: 5,
          }}
        />
        <ListItemIcon
          sx={{
            minWidth: 0,
            justifyContent: 'center',
          }}
        >
          {Icon}
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={{ color: colorShades.greyShade, noWrap: true, pl: 1.5 }}
          primary={moduleName || caption}
        />
        {children}
      </ListItemButton>
    </ListItem>
  );
}

export default SingleLevelItem;
